import util from '../util/util';
export default {
    // 轮播图数据
    section1: {
        // 图片地址
        link: util.get_img('about_banner.png'),
        // 标题
        title: '基于AI算法的品质内容广告平台',
        // 描述
        description: '我们以网易独家资源和有道媒体矩阵为核心，依托人工智能与大数据技术赋能内容广告，同时搭配专业服务，致力于帮助广告主实现精准、透明、高效的一站式投放，协助开发者实现高效益的流量变现'
    },
    // 平台优势块数据
    section2: {
        // 模块名称
        name: '有道智选大事记',
        data: [
            {
                // 时间
                year: '2018',
                data: [
                    {
                        month: '04',
                        event: '有道智选品质化产品全面升级'
                    }
                ]
            },
            {
                // 时间
                year: '2017',
                data: [
                    {
                        month: '12',
                        event: '获金触点全球商业创新大奖“最具技术创新力营销产品”称号'
                    },
                    {
                        month: '04',
                        event: '获金鼠标奖“年度最佳数字营销平台”称号'
                    }
                ]
            },
            {
                // 时间
                year: '2016',
                data: [
                    {
                        month: '11',
                        event: '获金触点全球商业创新大奖“最具技术创新力营销产品”'
                    },
                    {
                        month: '10',
                        event: '获TMA“年度最佳移动广告投放平台”'
                    }
                ]
            },
            {
                // 时间
                year: '2015',
                data: [
                    {
                        month: '12',
                        event: '获金触点“实效大数据营销平台”称号、“顶尖营销案例银奖”'
                    },
                    {
                        month: '11',
                        event: '获2015TMA“移动营销创新平台”'
                    },
                    {
                        month: '7',
                        event: '国际知识发现和数据挖掘竞赛（KDD-CUP）第一名'
                    },
                    {
                        month: '6',
                        event: 'RecSys电商产品推荐比赛第三名'
                    },
                    {
                        month: '3',
                        event: 'Kaggle国际移动端广告点击率预测竞赛第三名'
                    }
                ]
            },
            {
                // 时间
                year: '2014',
                data: [
                    {
                        month: '11',
                        event: '获2014TMA“移动营销创新平台”'
                    },
                    {
                        month: '10',
                        event: '获艾瑞营销奖中“2014年度中国最佳网络广告案例奖”'
                    },
                    {
                        month: '',
                        event: '...'
                    }
                ]
            }
        ]
    },
    // 所获荣誉块数据
    section3: {
        // 模块名称
        name: '所获荣誉',
        data: [
            {
                // 图片地址
                link: util.get_img('about_p_2.png'),
                // 标题
                title: '年度最佳数字营销平台',
                // 描述
                description: '金鼠标'
            },
            {
                // 图片地址
                link: util.get_img('about_p_3.png'),
                // 标题
                title: '国际知识发现和数据挖掘竞赛第一名',
                // 描述
                description: 'KDD CUP 2015'
            },
            {
                // 图片地址
                link: util.get_img('about_p_4.png'),
                // 标题
                title: '年度最佳移动广告投放平台',
                // 描述
                description: 'TMA'
            },
            {
                // 图片地址
                link: util.get_img('about_p_5.png'),
                // 标题
                title: 'RecSys电商产品推荐比赛TOP3',
                // 描述
                description: 'RecSys Challenge 2015'
            },
            {
                // 图片地址
                link: util.get_img('about_p_6.png'),
                // 标题
                title: '国际移动端广告点击率预测竞赛TOP3',
                // 描述
                description: 'Kaggle'
            },
            {
                // 图片地址
                link: util.get_img('about_p_7.png'),
                // 标题
                title: '年度中国最佳网络广告案例奖',
                // 描述
                description: '艾瑞咨询集团'
            },
            {
                // 图片地址
                link: util.get_img('about_p_1.png'),
                // 标题
                title: '最具技术创新力营销产品',
                // 描述
                description: '金触点'
            }
        ]
    },
    // 联系我们块数据
    section4: {
        // 模块名称
        name: '联系我们',
        data: [
            {
                // 图片地址
                link: util.get_img('honer_place_1.png'),
                // 地点
                place: '北京',
                // 邮编
                zip: '100089',
                // 地址
                address: '北京市海淀区西北旺东路中关村软件园二期西区7号',
                // 活跃态
                active: true
            },
            {
                // 图片地址
                link: util.get_img('honer_place_2.png'),
                // 地点
                place: '上海',
                // 邮编
                zip: '200080',
                // 地址
                address: '上海市虹口区溧阳路735号半岛湾创意产业园2号楼208室'
            },
            {
                // 图片地址
                link: util.get_img('honer_place_3.png'),
                // 地点
                place: '广州',
                // 邮编
                zip: '510000',
                // 地址
                address: '广州市天河区思蕴路5号网易高唐园区A3栋'
            },
            {
                // 图片地址
                link: util.get_img('honer_place_4.png'),
                // 地点
                place: '东莞',
                // 邮编
                zip: '523073',
                // 地址
                address: '东莞市南城区石竹路3号广发金融大厦A座1502'
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/data/about.js